import { render, staticRenderFns } from "./PorchColor.vue?vue&type=template&id=45599afe&scoped=true&"
import script from "./PorchColor.vue?vue&type=script&lang=js&"
export * from "./PorchColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45599afe",
  null
  
)

export default component.exports